import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_LAND_USE_SUITABILITY',
  name: 'Workspace Project Land Use Suitability',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'projectType', title: 'Project Type' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
